/*
 * @Author:
 * @Description:
 * @Date: 2024-11-20 19:21:18
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/risk/api/options.js
 */
export const RISK_DECISION = [{
  value: 'BLACKLIST',
  label: 'message.risk.blacklist',
}];

export const RISK_FACTOR = [{
  value: 'CARD_NUMBER_HASH',
  label: 'message.tableCommon.cardNumber', // 卡号
}, {
  value: 'PHONE',
  label: 'message.risk.phone', // 手机号
}, {
  value: 'IP',
  label: 'message.risk.ip', // IP地址
}, {
  value: 'EMAIL',
  label: 'message.risk.email', // 邮箱
}, {
  value: 'EMAIL_DOMAIN',
  label: 'message.risk.emailDomain', // 邮箱域名
}];

export const RULE_PRODUCT_TYPE_OPTIONS = [
  { label: 'message.risk.card', value: 'CARD', desc: 'message.risk.addBlacklistdialog.cardDesc' },
  { label: 'message.risk.lpms', value: 'LPMS', desc: 'message.risk.addBlacklistdialog.lpmsDesc' },
  { label: 'message.risk.all', value: 'ALL', desc: 'message.risk.addBlacklistdialog.allDesc' },
];

export const TAB_LIST = [
  { label: 'message.risk.manualInput', value: 'MANUAL_INPUT' },
  { label: 'message.risk.uploadCsv', value: 'UPLOAD_CSV' },
];
